'use client'

import type { Data } from '@repo/strapi'
import { useQuery } from '@tanstack/react-query'
import type { APIResponse } from '@/types/api'
import type { AppLocale } from '@/types/general'

async function fetchCSRNotFoundData(locale: AppLocale) {
	const response = await fetch(`/api/error-data/${locale}`)
	if (response.ok) {
		const data = await response.json()
		return data as APIResponse<Data.ContentType<'api::not-found.not-found'>>
	}
	return null
}

const useNotFoundData = ({ locale }: { locale: AppLocale }) =>
	useQuery({
		queryKey: ['not-found', locale],
		queryFn: () => fetchCSRNotFoundData(locale),
	})

export default useNotFoundData
